import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogueHandler, BankSuccessDialogueHandler } from './types';
import BankSuccessContext from './BankSuccessContext';

const { ConfirmationDialogue } = vp;

type BankSuccessDialogueProps = {
  handleDialogue: DialogueHandler<BankSuccessDialogueHandler>;
};

type FC = FunctionComponent<BankSuccessDialogueProps>;

const BankSuccessDialogue: FC = ({ handleDialogue }: BankSuccessDialogueProps) => {
  const { showConnectBankSuccessAlert } = useContext(BankSuccessContext);
  const { t } = useTranslation('translations', { keyPrefix: 'BankDialouge' });
  return useMemo(
    () => (
      <div>
        {/* Create Credit Card Success */}
        <ConfirmationDialogue
          isVisible={showConnectBankSuccessAlert}
          title={`${t('successfulConnection')}`}
          status="success"
          subTitle=""
          confirm={{
            label: `${t('doneButton')}`,
            action: () => handleDialogue({ type: 'create', state: 'success' }),
          }}
        />
        {/* Create Credit Card Fail */}
      </div>
    ),
    [showConnectBankSuccessAlert],
  );
};

export default BankSuccessDialogue;
